var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',[_vm._t("toggle",null,null,attrs)],2)]}}],null,true)},'v-dialog',_vm.$attrs,false),_vm.$listeners),[_vm._t("modal")],2)}
var staticRenderFns = []

export { render, staticRenderFns }